import { computed, useSignal } from '@preact/signals'
import { useEffect } from 'preact/hooks'
import { UseCase } from 'core'

import { CreateDAppFromPromptTemplate } from 'components/template'

import {
	createDAppFromPrompt,
	dAppDescriptionState,
	dAppNameState,
	getUseCases,
	formErrors,
	isDAppLoading,
	setDAppDescription,
	setDAppName,
	selectedUseCasesState,
	toggleUseCaseSelection,
	resetDAppForm,
	promptState,
	setPromptValue
} from './state'

const LOADING_USE_CASES: UseCase[] = Array.from({ length: 4 }, (_, i) => ({
	id: i.toString(),
	name: '&nbsp;',
	subtitle: '&nbsp;',
	description: '&nbsp;',
	content: '&nbsp;',
	createdAt: '&nbsp;',
	updatedAt: '&nbsp;',
	version: '&nbsp;'
}))

const isButtonDisabled = computed(
	() =>
		dAppNameState.value === '' ||
		isDAppLoading.value ||
		!!formErrors.value.name ||
		!!formErrors.value.description
)

const CreateDAppFromPromptPage = () => {
	const hideAdditionalUseCases = useSignal(true)
	const isLoading = useSignal(true)
	const useCases = useSignal<UseCase[]>(LOADING_USE_CASES)
	const useCasesFiltered = useSignal<UseCase[]>(LOADING_USE_CASES)

	useEffect(() => resetDAppForm, [])

	useEffect(() => {
		getUseCases().then(data => {
			useCases.value = data!
			useCasesFiltered.value = data!
			isLoading.value = false
		})
	}, [isLoading, useCases, useCasesFiltered])

	return (
		<CreateDAppFromPromptTemplate
			createDAppFromPrompt={createDAppFromPrompt}
			dAppDescription={dAppDescriptionState}
			dAppName={dAppNameState}
			filteredUseCases={useCasesFiltered.value}
			formErrors={formErrors}
			hideAdditionalUseCases={hideAdditionalUseCases}
			isButtonDisabled={isButtonDisabled}
			isLoading={isLoading}
			promptValue={promptState.value}
			selectedUseCases={selectedUseCasesState}
			setPromptValue={setPromptValue}
			toggleUseCaseSelection={toggleUseCaseSelection}
			updateDAppDescription={setDAppDescription}
			updateDAppName={setDAppName}
			visibleUseCases={6}
		/>
	)
}

export { CreateDAppFromPromptPage }
